module.exports = __webpack_public_path__ + "04918f2983ca50a57158f843b3c1b274.svg";